<template>
    <el-container>
        <el-header>
            <el-form :inline="true" :model="queryPluginParam" class="demo-form-inline">
                <el-form-item :label="$t('pgCommon.PLUGIN_ID')" prop="pluginId" style="padding-left:15px">
                    <td-input v-model="queryPluginParam.pluginId"></td-input>
                </el-form-item>
                <el-form-item :label="$t('common.PLUGIN_NAME')" prop="pluginName" style="padding-left:15px">
                    <td-input v-model="queryPluginParam.pluginName"></td-input>
                </el-form-item>
                <el-form-item :label="$t('common.ISUSED')" prop="enable" style="padding-left:15px">
                    <td-select v-model="queryPluginParam.enable" keys="iId" text="sName" :options="enabledStatusList" :collapse-tags="true" :placeholder="$t('common.PLEASE_SELECT')"></td-select>
                </el-form-item>
                <el-form-item :label="$t('common.RUNSTATUS')" prop="pluginState" style="padding-left:15px">
                    <td-select v-model="queryPluginParam.pluginState" keys="iId" text="sName" :options="pluginStateList" :collapse-tags="true" :placeholder="$t('common.PLEASE_SELECT')"></td-select>
                </el-form-item>
                <el-form-item :label="$t('common.PLUGIN_AUTH_STATUS')" prop="authStatus" style="padding-left:15px">
                    <td-select
                        v-model="queryPluginParam.authStatus"
                        keys="iId"
                        text="sName"
                        :options="pluginAuthStatusList"
                        :collapse-tags="true"
                        :placeholder="$t('common.PLEASE_SELECT')"
                    ></td-select>
                </el-form-item>
                <el-form-item>
                    <td-button type="primary" size="medium" :permissions="permissionsSearch" @click="search" style="width:100px;margin-left:12px;">{{ $t('pgCommon.QUERY') }}</td-button>
                    <td-button size="medium" :permissions="permissionsInstall" @click="install" style="width:100px;">{{ $t('pgCommon.INSTALLPLUGIN') }}</td-button>
                    <td-button size="medium" :permissions="permissionsInstall" @click="upgrade" style="width:100px;margin-left:12px;">{{ $t('pgCommon.UPGRADE_PLUGIN') }}</td-button>
                    <td-button size="medium" :permissions="permissionsInstall" @click="enableAll" style="width:100px;margin-left:12px;">{{ $t('pgCommon.USE_PLUGIN') }}</td-button>
                    <td-button size="medium" :permissions="permissionsInstall" @click="disableAll" style="width:100px;margin-left:12px;">{{ $t('pgCommon.UNUSE_PLUGIN') }}</td-button>
                    <td-button size="medium" :permissions="permissionsInstall" @click="startAll" style="width:100px;margin-left:12px;">{{ $t('pgCommon.STARTPLUGIN') }}</td-button>
                    <td-button size="medium" :permissions="permissionsInstall" @click="stopAll" style="width:100px;margin-left:12px;">{{ $t('pgCommon.STOPPLUGIN') }}</td-button>
                </el-form-item>
            </el-form>
        </el-header>
        <el-main>
            <!-- 加载表格 -->
            <td-table
                :permissions="permissionsSearch"
                rowKey="pluginId"
                :columns="columns"
                :dataSource="tableData"
                :pageSize="pageSize"
                :currentPage="currentPage"
                :total="total"
                :hasLoading="loading"
                :hasIndex="false"
                ref="pluginList"
                @handleSizeChange="handleSizeChange"
                @currentChange="handleCurrentChange"
                @getSortData="getSortData"
                :hasDraggable="true"
            ></td-table>
        </el-main>
        <installPlugin v-if="installDialogVisible" :dialogVisible="installDialogVisible" @addDialogClose="addDialogClose" @querypluginLIst="querypluginLIst"></installPlugin>
        <upgradePlugin v-if="upgradeDialogVisible" :dialogVisible="upgradeDialogVisible" @upgradeDialogClose="upgradeDialogClose"></upgradePlugin>
    </el-container>
</template>
<script>
import pluginApi from './assets/api.js';
import installPlugin from './components/installPlugin';
import upgradePlugin from './components/upgradePlugin';
export default {
    components: {
        installPlugin: installPlugin,
        upgradePlugin: upgradePlugin
    },
    mounted() {
        this.initData();
    },
    data() {
        return {
            permissionsInstall: ['plugin:operation', 'plugin:view'],
            permissionsSearch: ['plugin:view'],
            installDialogVisible: false, // 控制dialog是否显示 true：显示   false：不显示
            upgradeDialogVisible: false,
            enabledStatusList: [
                {
                    iId: true,
                    sName: this.$t('common.ISUSING')
                },
                {
                    iId: false,
                    sName: this.$t('common.UNUSING')
                }
            ],
            pluginStateList: [
                {
                    iId: window.pgCommon.pluginState.LOADED,
                    sName: this.$t('pgCommon.LOADED')
                },
                {
                    iId: window.pgCommon.pluginState.STARTED,
                    sName: this.$t('pgCommon.STARTED')
                },
                {
                    iId: window.pgCommon.pluginState.STARTFAILED,
                    sName: this.$t('pgCommon.STARTFAILED')
                }
            ],
            pluginAuthStatusList: [
                {
                    iId: window.pgCommon.pluginAuthStatus.NO_NEED,
                    sName: this.$t('common.NONEEDAUTH')
                },
                {
                    iId: window.pgCommon.pluginAuthStatus.AUTHORIZED,
                    sName: this.$t('common.ISAUTH')
                },
                {
                    iId: window.pgCommon.pluginAuthStatus.UNAUTHORIZED,
                    sName: this.$t('common.UNAUTH')
                }
            ],
            currentPage: 1, // 当前页
            pageSizes: [10, 50, 100], // 分页组
            total: 0, // 总数
            tableData: [], // 列表数据
            multipleSelection: [], // 列表选中的列组合
            loading: false, // 是否显示遮罩层 true：显示  false：不显示
            pageSize: 10, // 默认每页条数
            queryPluginParam: {
                pluginId: '',
                pluginName: ''
            },
            columns: [
                {
                    prop: 'pluginId',
                    label: 'pgCommon.PLUGIN_ID',
                    tableWidth: '170',
                    showOverflowTooltip: true
                },
                {
                    prop: 'pluginName',
                    label: 'common.PLUGIN_NAME',
                    tableWidth: '140',
                    showOverflowTooltip: true
                },
                {
                    prop: 'version',
                    label: 'common.VERSION',
                    align: 'center',
                    tableWidth: '60'
                },
                {
                    prop: 'dependencies',
                    label: 'common.DEPENDS',
                    tableWidth: '100',
                    showOverflowTooltip: true
                },
                {
                    prop: 'sModuleId',
                    label: 'common.SMODULEID',
                    tableWidth: '110'
                },
                {
                    prop: 'bootOrder',
                    label: 'pgCommon.PLUGIN_INIT_ORDER',
                    align: 'center',
                    tableWidth: '50',
                    render: (createElement, params) => {
                        if (params.row.bootOrder === 999) {
                            return createElement('span', '');
                        }
                        return createElement('span', params.row.bootOrder);
                    }
                },
                {
                    prop: 'pluginDescription',
                    label: 'common.DESCRIPTION',
                    showOverflowTooltip: true
                },
                {
                    prop: 'enable',
                    label: 'common.ISUSED',
                    align: 'center',
                    tableWidth: '80',
                    render: (createElement, params) => {
                        if (params.row.enable === false) {
                            return createElement('span', this.$t('common.DISABLE'));
                        }
                        return createElement('span', this.$t('common.ISUSING'));
                    }
                },
                {
                    prop: 'pluginState',
                    label: 'common.RUNSTATUS',
                    align: 'center',
                    tableWidth: '80',
                    render: (createElement, params) => {
                        if (params.row.pluginState === window.pgCommon.pluginState.LOADED) {
                            return createElement('span', this.$t('pgCommon.LOADED'));
                        } else if (params.row.pluginState === window.pgCommon.pluginState.STARTED) {
                            return createElement('span', this.$t('pgCommon.STARTED'));
                        } else if (params.row.pluginState === window.pgCommon.pluginState.STOPPED) {
                            return createElement('span', this.$t('pgCommon.STOPPED'));
                        } else if (params.row.pluginState === window.pgCommon.pluginState.STARTFAILED) {
                            return createElement('span', this.$t('pgCommon.STARTFAILED'));
                        }
                        return createElement('span', this.$t('common.PLUGIN_FILE_NO_FIND'));
                    }
                },
                {
                    prop: 'authStatus',
                    label: 'common.PLUGIN_AUTH_STATUS',
                    align: 'center',
                    tableWidth: '80',
                    render: (createElement, params) => {
                        if (params.row.authStatus === window.pgCommon.pluginAuthStatus.NO_NEED) {
                            return createElement('span', this.$t('common.NONEEDAUTH'));
                        } else if (params.row.authStatus === window.pgCommon.pluginAuthStatus.AUTHORIZED) {
                            return createElement('span', this.$t('common.ISAUTH'));
                        } else if (params.row.authStatus === window.pgCommon.pluginAuthStatus.UNAUTHORIZED) {
                            return createElement('span', this.$t('common.UNAUTH'));
                        }
                        return createElement('span', this.$t('common.NONEEDAUTH'));
                    }
                },
                {
                    prop: '',
                    label: 'common.OPERATE',
                    tableWidth: '150',
                    align: 'center',
                    render: (createElement, params) => {
                        let b1 = createElement(
                            'td-button',
                            {
                                props: { type: 'text', size: 'small', permissions: ['plugin:operation', 'plugin:view'] },
                                on: {
                                    click: () => {
                                        this.enable(params.row);
                                    }
                                }
                            },
                            this.$t('common.START')
                        );
                        let b2 = createElement(
                            'td-button',
                            {
                                props: { type: 'text', size: 'small', permissions: ['plugin:operation', 'plugin:view'] },
                                on: {
                                    click: () => {
                                        this.disable(params.row);
                                    }
                                }
                            },
                            this.$t('common.DISABLE')
                        );
                        let b3 = createElement(
                            'td-button',
                            {
                                props: { type: 'text', size: 'small', permissions: ['plugin:operation', 'plugin:view'] },
                                on: {
                                    click: () => {
                                        this.start(params.row);
                                    }
                                }
                            },
                            this.$t('pgCommon.RUN_PLUGIN')
                        );
                        let b4 = createElement(
                            'td-button',
                            {
                                props: { type: 'text', size: 'small', permissions: ['plugin:operation', 'plugin:view'] },
                                on: {
                                    click: () => {
                                        this.stop(params.row);
                                    }
                                }
                            },
                            this.$t('pgCommon.STOP_PLUGIN')
                        );
                        let b5 = createElement(
                            'td-button',
                            {
                                props: { type: 'text', size: 'small', permissions: ['plugin:operation', 'plugin:view'] },
                                on: {
                                    click: () => {
                                        this.unInstall(params.row);
                                    }
                                }
                            },
                            this.$t('common.UNSTALLPLUGIN')
                        );
                        let b6 = createElement(
                            'td-button',
                            {
                                props: { type: 'text', size: 'small', permissions: ['plugin:operation', 'plugin:view'] },
                                on: {
                                    click: () => {
                                        this.allocation(params.row);
                                    }
                                }
                            },
                            this.$t('common.ALLOCATION')
                        );
                        let list = [];
                        if (params.row.enable === false && params.row.pluginState !== window.pgCommon.pluginState.UNLOADED) {
                            list.push(b1);
                        }
                        if (params.row.enable === true && params.row.pluginState !== window.pgCommon.pluginState.UNLOADED) {
                            list.push(b2);
                        }
                        if (params.row.enable === true && params.row.pluginState !== window.pgCommon.pluginState.STARTED && params.row.pluginState !== window.pgCommon.pluginState.UNLOADED) {
                            list.push(b3);
                        }
                        if (params.row.enable === true && params.row.pluginState === window.pgCommon.pluginState.STARTED) {
                            list.push(b4);
                        }
                        if (params.row.pluginState !== window.pgCommon.pluginState.STARTE) {
                            list.push(b5);
                        }
                        // list.push(b6)
                        return createElement('div', list);
                    }
                }
            ]
        };
    },
    methods: {
        // 初始化页面数据
        initData: function() {
            this.querypluginLIst();
        },
        // 查询插件列表数据
        querypluginLIst() {
            this.loading = true;
            let queryVo = {};
            queryVo.isPage = true;
            queryVo.pageNum = this.currentPage;
            queryVo.pageSize = this.pageSize;
            queryVo.pluginId = this.queryPluginParam.pluginId;
            queryVo.pluginName = this.queryPluginParam.pluginName;
            queryVo.authStatus = this.queryPluginParam.authStatus;
            queryVo.pluginState = this.queryPluginParam.pluginState;
            queryVo.enable = this.queryPluginParam.enable;

            let json = JSON.stringify(queryVo);
            pluginApi.queryPluginList(json, response => {
                this.$log.info('/plugin/listPlugins', response);
                if (response.status === window.pgCommon.login.RESPONSE_STATUS && response.data) {
                    if (response.data.statusCode === window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                        this.tableData = response.data.content;
                        this.total = response.data.count;
                        this.loading = false; // 关闭遮罩层
                    } else {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('/plugin/listPlugins', response.data.statusMessage);
                        this.loading = false; // 关闭遮罩层
                    }
                } else {
                    this.$message({ showClose: true, message: this.$t('common.OPERATION_FAIL'), type: 'error' });
                    this.$log.error('/plugin/listPlugins', response);
                    this.loading = false; // 关闭遮罩层
                }
            });
        },
        // 控制每页条数变化
        handleSizeChange(val) {
            this.pageSize = val;
            this.querypluginLIst();
        },
        // 控制页数变化
        handleCurrentChange(val) {
            this.currentPage = val;
            this.querypluginLIst();
        },
        // 点击安装插件
        install() {
            this.installDialogVisible = true;
        },
        // 卸载插件
        unInstall(row) {
            this.$confirm(this.$t('message.IS_CONFIRM_UNSTALL_THIS_PLUGIN'), this.$t('message.prompt'), {
                confirmButtonText: this.$t('common.CONFIRM'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    this.loading = true;
                    let fd = new FormData();
                    fd.append('pluginId', row.pluginId);
                    pluginApi.uninstall(fd, response => {
                        if (response.status === undefined) {
                            return;
                        }
                        if (response.status === window.pgCommon.login.RESPONSE_STATUS && response.data) {
                            if (response.data.statusCode === window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                                if (null !== response.data.content && response.data.content.length !== 0) {
                                    this.$message({ showClose: true, message: JSON.stringify(response.data.content), type: 'warning' });
                                    this.loading = true;
                                }
                                this.querypluginLIst();
                            } else {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('/plugin/listPlugins', response.data.statusMessage);
                                this.loading = false; // 关闭遮罩层
                            }
                        } else {
                            this.$message({ showClose: true, message: this.$t('common.OPERATION_FAIL'), type: 'error' });
                            this.$log.error('/plugin/listPlugins', response);
                            this.loading = false; // 关闭遮罩层
                        }
                    });
                })
                .catch(() => {});
        },
        // 关闭dialog
        addDialogClose() {
            this.installDialogVisible = false;
        },
        upgrade() {
            this.upgradeDialogVisible = true;
        },
        upgradeDialogClose() {
            this.upgradeDialogVisible = false;
        },

        getErrorInfo(content) {
            var errorStr = '';
            for (let i = 0; i < content.length; i++) {
                const info = content[i];
                errorStr += info;
                if (i != content.length - 1) {
                    errorStr += '</br>';
                }
            }
            return errorStr;
        },
        // 批量启用插件
        enableAll() {
            this.multipleSelection = this.$refs.pluginList.getSelectAllRows();
            if (this.multipleSelection.length === 0) {
                this.$message({ showClose: true, message: this.$t('message.PLEASE_CHOOSE_USING_PLUGIN'), type: 'warning' });
                return;
            }
            this.loading = true;
            let ids = [];
            for (let i = 0; i < this.multipleSelection.length; i++) {
                ids.push(this.multipleSelection[i].pluginId);
            }
            let param = {};
            param.enable = true;
            param.ids = ids;
            let json = JSON.stringify(param);
            pluginApi.setEnable(json, response => {
                if (response.status === window.pgCommon.login.RESPONSE_STATUS && response.data) {
                    if (response.data.statusCode === window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                        if (response.data.content.length !== 0) {
                            this.$message({ showClose: true, duration: 5000, dangerouslyUseHTMLString: true, message: this.getErrorInfo(response.data.content), type: 'error' });
                        }
                        this.querypluginLIst();
                    } else {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('/plugin/setEnable', response.data.statusMessage);
                        this.loading = false; // 关闭遮罩层
                    }
                } else {
                    this.$message({ showClose: true, message: this.$t('common.OPERATION_FAIL'), type: 'error' });
                    this.$log.error('/plugin/setEnable', response);
                    this.loading = false; // 关闭遮罩层
                }
            });
        },
        // 单个启用插件
        enable(row) {
            this.loading = true;
            let ids = [];
            ids.push(row.pluginId);
            let param = {};
            param.enable = true;
            param.ids = ids;
            let json = JSON.stringify(param);
            pluginApi.setEnable(json, response => {
                if (response.status === window.pgCommon.login.RESPONSE_STATUS && response.data) {
                    if (response.data.statusCode === window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                        if (response.data.content.length !== 0) {
                            this.$message({ showClose: true, message: this.getErrorInfo(response.data.content), type: 'error' });
                        }
                        this.querypluginLIst();
                    } else {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('/plugin/setEnable', response.data.statusMessage);
                        this.loading = false; // 关闭遮罩层
                    }
                } else {
                    this.$message({ showClose: true, message: this.$t('common.OPERATION_FAIL'), type: 'error' });
                    this.$log.error('/plugin/setEnable', response);
                    this.loading = false; // 关闭遮罩层
                }
            });
        },
        // 批量禁用插件
        disableAll() {
            this.multipleSelection = this.$refs.pluginList.getSelectAllRows();
            if (this.multipleSelection.length === 0) {
                this.$message({ showClose: true, message: this.$t('message.PLEASE_CHOOSE_UNUSING_PLUGIN'), type: 'warning' });
                return;
            }
            this.loading = true;
            let ids = [];
            for (let i = 0; i < this.multipleSelection.length; i++) {
                ids.push(this.multipleSelection[i].pluginId);
            }
            let param = {};
            param.enable = false;
            param.ids = ids;
            let json = JSON.stringify(param);
            pluginApi.setEnable(json, response => {
                if (response.status === window.pgCommon.login.RESPONSE_STATUS && response.data) {
                    if (response.data.statusCode === window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                        if (response.data.content.length !== 0) {
                            this.$message({ showClose: true, duration: 5000, dangerouslyUseHTMLString: true, message: this.getErrorInfo(response.data.content), type: 'error' });
                        }
                        this.querypluginLIst();
                    } else {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('/plugin/setEnable', response.data.statusMessage);
                        this.loading = false; // 关闭遮罩层
                    }
                } else {
                    this.$message({ showClose: true, message: this.$t('common.OPERATION_FAIL'), type: 'error' });
                    this.$log.error('/plugin/setEnable', response);
                    this.loading = false; // 关闭遮罩层
                }
            });
        },
        // 单个禁用插件
        disable(row) {
            this.loading = true;
            let ids = [];
            ids.push(row.pluginId);
            let param = {};
            param.enable = false;
            param.ids = ids;
            let json = JSON.stringify(param);
            pluginApi.setEnable(json, response => {
                if (response.status === window.pgCommon.login.RESPONSE_STATUS && response.data) {
                    if (response.data.statusCode === window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                        if (response.data.content.length !== 0) {
                            this.$message({ showClose: true, message: this.getErrorInfo(response.data.content), type: 'error' });
                        }
                        this.querypluginLIst();
                    } else {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('/plugin/setEnable', response.data.statusMessage);
                        this.loading = false; // 关闭遮罩层
                    }
                } else {
                    this.$message({ showClose: true, message: this.$t('common.OPERATION_FAIL'), type: 'error' });
                    this.$log.error('/plugin/setEnable', response);
                    this.loading = false; // 关闭遮罩层
                }
            });
        },
        // 批量开启插件
        startAll() {
            this.multipleSelection = this.$refs.pluginList.getSelectAllRows();
            if (this.multipleSelection.length === 0) {
                this.$message({ showClose: true, message: this.$t('message.PLEASE_CHOOSE_START_PLUGIN'), type: 'warning' });
                return;
            }
            this.loading = true;
            let ids = [];
            for (let i = 0; i < this.multipleSelection.length; i++) {
                ids.push(this.multipleSelection[i].pluginId);
            }
            let param = {};
            param.enable = true;
            param.ids = ids;
            let json = JSON.stringify(param);
            pluginApi.startPlugins(json, response => {
                if (response.status === window.pgCommon.login.RESPONSE_STATUS && response.data) {
                    if (response.data.statusCode === window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                        if (response.data.content.length !== 0) {
                            this.$message({ showClose: true, duration: 5000, dangerouslyUseHTMLString: true, message: this.getErrorInfo(response.data.content), type: 'error' });
                        }
                        this.querypluginLIst();
                    } else {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('/plugin/startPlugins', response.data.statusMessage);
                        this.loading = false; // 关闭遮罩层
                    }
                } else {
                    this.$message({ showClose: true, message: this.$t('common.OPERATION_FAIL'), type: 'error' });
                    this.$log.error('/plugin/startPlugins', response);
                    this.loading = false; // 关闭遮罩层
                }
            });
        },
        // 开启插件
        start(row) {
            this.loading = true;
            let ids = [];
            ids.push(row.pluginId);
            let param = {};
            param.enable = true;
            param.ids = ids;
            let json = JSON.stringify(param);
            pluginApi.startPlugins(json, response => {
                if (response.status === window.pgCommon.login.RESPONSE_STATUS && response.data) {
                    if (response.data.statusCode === window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                        if (response.data.content.length !== 0) {
                            this.$message({ showClose: true, message: this.getErrorInfo(response.data.content), type: 'error' });
                        }
                        this.querypluginLIst();
                    } else {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('/plugin/startPlugins', response.data.statusMessage);
                        this.loading = false; // 关闭遮罩层
                    }
                } else {
                    this.$message({ showClose: true, message: this.$t('common.OPERATION_FAIL'), type: 'error' });
                    this.$log.error('/plugin/startPlugins', response);
                    this.loading = false; // 关闭遮罩层
                }
            });
        },
        // 批量停止插件
        stopAll() {
            this.multipleSelection = this.$refs.pluginList.getSelectAllRows();
            if (this.multipleSelection.length === 0) {
                this.$message({ showClose: true, message: this.$t('message.PLEASE_CHOOSE_CLOSE_PLUGIN'), type: 'warning' });
                return;
            }
            this.loading = true;
            let ids = [];
            for (let i = 0; i < this.multipleSelection.length; i++) {
                ids.push(this.multipleSelection[i].pluginId);
            }
            let param = {};
            param.enable = true;
            param.ids = ids;
            let json = JSON.stringify(param);
            pluginApi.stopPlugins(json, response => {
                if (response.status === window.pgCommon.login.RESPONSE_STATUS && response.data) {
                    if (response.data.statusCode === window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                        if (response.data.content.length !== 0) {
                            this.$message({ showClose: true, duration: 5000, dangerouslyUseHTMLString: true, message: this.getErrorInfo(response.data.content), type: 'error' });
                        }
                        this.querypluginLIst();
                    } else {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('/plugin/stopPlugins', response.data.statusMessage);
                        this.loading = false; // 关闭遮罩层
                    }
                } else {
                    this.$message({ showClose: true, message: this.$t('common.OPERATION_FAIL'), type: 'error' });
                    this.$log.error('/plugin/stopPlugins', response);
                    this.loading = false; // 关闭遮罩层
                }
            });
        },
        // 停止插件
        stop(row) {
            this.loading = true;
            let ids = [];
            ids.push(row.pluginId);
            let param = {};
            param.enable = true;
            param.ids = ids;
            let json = JSON.stringify(param);
            pluginApi.stopPlugins(json, response => {
                if (response.status === window.pgCommon.login.RESPONSE_STATUS && response.data) {
                    if (response.data.statusCode === window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                        if (response.data.content.length !== 0) {
                            this.$message({ showClose: true, message: this.getErrorInfo(response.data.content), type: 'error' });
                        }
                        this.querypluginLIst();
                    } else {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('/plugin/stopPlugins', response.data.statusMessage);
                        this.loading = false; // 关闭遮罩层
                    }
                } else {
                    this.$message({ showClose: true, message: this.$t('common.OPERATION_FAIL'), type: 'error' });
                    this.$log.error('/plugin/stopPlugins', response);
                    this.loading = false; // 关闭遮罩层
                }
            });
        },
        //获取排序后的表格数据，并更新数据库
        getSortData(oldIndex, newIndex, formatData) {
            let startIdx = (this.currentPage - 1) * this.pageSize;
            for (let i = 0; i < formatData.length; i++) {
                formatData[i].bootOrder = startIdx + i + 1;
            }
            pluginApi.updateSortInfo(JSON.stringify(formatData), response => {
                if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                    this.$log.error('/plugin/updateSortInfo', response);
                    this.loading = false; // 关闭遮罩层
                }
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/plugin/updateSortInfo', response.data.statusMessage);
                    this.loading = false; // 关闭遮罩层
                }
                this.querypluginLIst();
            });
        },

        // 查询
        search() {
            this.querypluginLIst();
        }
    }
};
</script>
